import type {
    LibraryDiagram,
    LibraryImage,
} from '@modules/product/type/product-gallery-types';

/**
 * Whether a still sits contained on the neutral fill and multiplies into it
 * rather than taking the cover-crop. Clear-cut renders do, and so do diagrams:
 * a line drawing on white loses its dimensions to any crop.
 */
export const isContainedSlide = (
    slide: LibraryImage | LibraryDiagram,
): boolean =>
    slide.__typename === 'DiagramImage' || Boolean(slide.IsMultiplied);
